import _extends from 'babel-runtime/helpers/extends';
/** 通讯录路由 */
import Layout from '@/views/layout/AddressBookLayout';

var layout = function layout(hidden) {
  var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return {
    path: '/addressBook',
    component: Layout,
    alwaysShow: false,
    hidden: hidden,
    meta: _extends({
      requiresAuth: false,
      permissions: ['oa', 'book']
    }, meta)
  };
};

export default [_extends({}, layout(true), {
  children: [{
    path: 'index/:type',
    meta: {
      redirect: 'index/all' // 获取传参的重置链接
    },
    component: function component() {
      return import('@/views/addressBook/index');
    }
  }]
}), _extends({}, layout(false), {
  ignore: true, // 路由添加时忽略
  children: [{
    path: 'index/all',
    meta: {
      title: '全部',
      icon: 'all'
    }
  }]
}), _extends({}, layout(false), {
  ignore: true,
  children: [{
    path: 'index/attention',
    meta: {
      title: '我的关注',
      icon: 'focus-on'
    }
  }]
})];